module.exports = __webpack_public_path__ + "fonts/notosans-regular-web.a0735f9.woff";